// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".textarea-description[data-v-4bf4794b]{margin-bottom:10px;font-size:14px}textarea[data-v-4bf4794b]{resize:vertical}.form-labels[data-v-4bf4794b],.textarea-description[data-v-4bf4794b]{font-size:16px}\n", ""]);
// Exports
module.exports = exports;
